import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "lw_distributor_token";

const DistributorAuthContext = createContext(null);

export const useDistributorAuth = () => useContext(DistributorAuthContext);

export const DistributorAuthProvider = ({ children }) => {
  const [distributor, setDistributor] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) {
      setDistributor(null);
      setLoading(false);
      return;
    }
    try {
      const res = await axios.get(`${API}/distributors/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setDistributor(res.data);
    } catch {
      localStorage.removeItem(TOKEN_KEY);
      setDistributor(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  const login = async (email, password) => {
    const res = await axios.post(`${API}/distributors/login`, { email, password });
    localStorage.setItem(TOKEN_KEY, res.data.token);
    setDistributor(res.data.distributor);
    return res.data.distributor;
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setDistributor(null);
  };

  const getToken = () => localStorage.getItem(TOKEN_KEY);

  return (
    <DistributorAuthContext.Provider
      value={{ distributor, loading, login, logout, getToken, refresh: fetchMe }}
    >
      {children}
    </DistributorAuthContext.Provider>
  );
};
